module.exports = __webpack_public_path__ + "static/media/classic-athletics-secondary.ba9c73c4.jpg";